// app/javascript/controllers/generic_reveal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "focus", "form"]

  toggle(e) {
    e?.preventDefault()
    this.panelTarget.classList.toggle("reveal-open")

    if (this.panelTarget.classList.contains("reveal-open") && this.hasFocusTarget) {
      this.focusTarget.focus()
    }
  }

  hide(e) {
    e?.preventDefault()
    this.panelTarget.classList.remove("reveal-open")
  }

  afterSubmit(e) {
    if (e.detail?.success) this.hide(e)  // lets the CSS transition finish
  }
}

